const SPOTLIGHTS = [
  {
    title: '2026暑期韩漫追更指南',
    desc: '暑假必追韩漫清单，从恋爱甜宠到奇幻冒险，精选各大韩漫网站当前最热连载作品，帮你规划假期追更路线。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20illustration%20of%20a%20person%20reading%20digital%20comics%20on%20a%20tablet%20in%20a%20sunlit%20room%20with%20plants%2C%20soft%20cream%20and%20beige%20background%2C%20artistic%20illustration%20style%20with%20gentle%20warm%20lighting%2C%20peaceful%20reading%20atmosphere%2C%20editorial%20quality&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
    tag: '追更指南',
    date: '2026.07',
  },
  {
    title: '韩漫网站入门：从零开始追韩漫',
    desc: '新手友好指南，介绍韩漫网、韩漫之家、韩漫屋等主流平台的注册与使用方式，帮你快速融入韩漫世界。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20illustration%20of%20a%20beginner%20guide%20concept%20with%20colorful%20comic%20speech%20bubbles%20and%20navigation%20arrows%20on%20a%20warm%20cream%20background%2C%20soft%20pastel%20accents%2C%20modern%20flat%20illustration%20style%2C%20friendly%20and%20inviting%20atmosphere&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
    tag: '入门指南',
    date: '2026.07',
  },
  {
    title: '热门韩漫恋爱题材作品精选',
    desc: '盘点各大韩漫漫画网站近期最受欢迎的恋爱题材作品，从校园初恋到职场恋情，甜蜜满分不容错过。',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20artistic%20illustration%20of%20two%20characters%20in%20a%20cherry%20blossom%20scene%20with%20soft%20pink%20and%20warm%20beige%20tones%2C%20gentle%20watercolor%20style%20with%20delicate%20details%2C%20dreamy%20atmosphere%2C%20editorial%20romance%20aesthetic&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
    tag: '题材精选',
    date: '2026.07',
  },
  {
    title: '韩漫更新动态：本周必看新番',
    desc: '实时追踪韩漫更新信息，汇总本周各大平台上线的新番和热门连载更新，让你不错过任何精彩内容。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20a%20calendar%20with%20colorful%20comic%20panels%20bursting%20out%2C%20bright%20warm%20colors%20on%20cream%20background%2C%20energetic%20and%20playful%20flat%20illustration%20style%2C%20editorial%20update%20announcement%20aesthetic&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
    tag: '新番速递',
    date: '2026.07',
  },
  {
    title: '韩漫屋 vs 韩漫之家：平台对比',
    desc: '深度对比韩漫屋与韩漫之家两大热门韩漫平台，从内容量、更新速度到阅读体验，帮你选择最适合的韩漫入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20comparison%20concept%20illustration%20with%20two%20devices%20side%20by%20side%20showing%20different%20comic%20interfaces%2C%20warm%20neutral%20beige%20background%2C%20modern%20minimalist%20flat%20illustration%20style%2C%20professional%20editorial%20quality&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
    tag: '平台对比',
    date: '2026.07',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精心策划的韩漫专题内容，助您发现更多精彩韩漫资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {SPOTLIGHTS.slice(0, 2).map((item, i) => (
            <article
              key={i}
              className={`bg-background-50 rounded-lg overflow-hidden border border-background-200/70 ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {SPOTLIGHTS.slice(2).map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}